<template>
  <section id="hero" data-component="hero">
    <LazyBg :src="bgSrc" eager />
    <canvas ref="canvasEl" id="hero-canvas">您的浏览器不支持 Canvas 动画</canvas>
    <div class="hero-overlay" />
    <div class="hero-content">
      <div class="hero-badge">
        AI加速服务
      </div>
      <h1 class="display-xl hero-title">
        万卡级异构算力集群<br /><span class="gradient-text">分布式训练与推理加速</span>
      </h1>
      <p class="hero-subtitle">
        提供极致弹性的分布式训练与推理加速环境，实现多任务智能分配与高速流转。支持DeepSpeed/Megatron-LM分布式训练加速框架，Spine-Leaf 200G/400G高速互联，GPUDirect RDMA零拷贝微秒级时延。
      </p>
      <div class="hero-actions">
        <RouterLink :to="{ path: '/', hash: '#cta-contact' }" class="btn-primary">
          获取AI算力方案
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/AI_bg1.jpg';
import LazyBg from '@/components/LazyBg.vue';
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { useHeroCanvas } from '@/composables/useHeroCanvas';
import '@/styles/newhome/home/hero.css';

const canvasEl = ref<HTMLCanvasElement | null>(null);
useHeroCanvas(canvasEl);
</script>
<style scoped lang="scss">
 #hero {
  /* bg via LazyBg */
}
</style>